<template>
  <div style="padding:10px">
    <van-pull-refresh
      v-model="isRefresh"
      :head-height="80"
      success-text="刷新成功"
      @refresh="getList"
    >
      <!-- <van-list v-model="loading" :finished="finished" @load="onLoad"> -->
      <div class="content" v-if="list.length > 0">
        <div class="houseList" v-for="(item, index) in list" :key="index">
          <div class="head font-16">
            <van-icon
              name="wap-home-o"
              color="orange"
              size="26"
              style="margin-right:5px;"
            />
            {{ item.housingEstateName }}
          </div>
          <div class="detail font-14">
            <div>楼栋号：{{ item.buildingNumber }}</div>
            <div>门牌号：{{ item.apartmentNumber }}</div>
            <div>
              地址：{{
                item.provinceName +
                  item.cityName +
                  item.areaName +
                  item.townName
              }}
            </div>
          </div>
          <div class="oneClick">
            <van-button
              class="expand font-14"
              plain
              round
              @click="edit(item.housingApartmentId)"
              >修改取信密码</van-button
            >
          </div>
        </div>
      </div>
      <!-- </van-list> -->
      <div class="flex" style="height:80vh" v-if="list.length === 0">
        <van-empty description="您当前没有可使用的信包箱~" />
      </div>
    </van-pull-refresh>

    <!-- :image="require('@/../static/banner.jpg')" -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRefresh: false,
      loading: false,
      finished: false,
      list: [],
      phone: ''
    }
  },
  created() {
    this.phone = JSON.parse(localStorage.getItem('userInfo')).mobile
    // this.phone = '18850783022'
    this.getList()
  },
  methods: {
    getList() {
      this.$api
        .getHousingList(this.phone)
        .then(res => {
          this.isRefresh = false
          this.list = res
        })
        .catch(() => {
          this.isRefresh = false
        })
    },
    edit(id) {
      this.$router.push({ name: 'editLetterPassword', query: { id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.houseList {
  // padding: 0 15px 10px;
  overflow: hidden;
  border-radius: 15px;
  background-color: #fff;
  margin-bottom: 10px;
  .head {
    display: flex;
    align-items: flex-end;
    font-weight: 700;
    margin: 15px 15px 10px;
  }
  .detail {
    border-bottom: 1px solid #f1f1f1;
    border-top: 1px solid #f1f1f1;
    padding: 5px 15px;
    div {
      margin: 5px 0;
    }
  }
  .oneClick {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 25px 10px;
    .expand {
      padding: 0 10px;
      border-radius: 15px;
      box-sizing: border-box;
      height: 30px;
      border: 1px solid #ff6600;
      color: #ff6600 !important;
    }
  }
}
.van-pull-refresh {
  height: calc(100vh - 20px) !important;
  overflow: auto !important;
}
</style>
